import React, { useState } from 'react';
import './buildingDelete.css';
import axiosInstance from '../../../utils/router/axiosInstance';
import { logger } from '../../../utils/logger';

const ModalBuildingDelete = ({ buildingId, setIsModalDeleteActive }) => {
  const [confirmation, setConfirmation] = useState('');
  const [confirmed, setConfirmed] = useState(false);

  const handleConfirmationChange = (e) => {
    setConfirmation(e.target.value);
    setConfirmed(e.target.value.toLowerCase() === 'удалить');
  };

  const handleDelete = () => {
    if (confirmed) {
      axiosInstance
        .delete(`website/building/${buildingId}`)
        .then((response) => {
          logger.debug('Employee deleted successfully');
          window.location.reload();
          setIsModalDeleteActive(false);
        })
        .catch((error) => {
          logger.error('Error deleting employee:', error);
        });
    }
  };

  return (
    <div className="BuildingDelete">
      <p className="DeleteInfo">ВНИМАНИЕ!</p>
      <p className="DeleteInfo">Если вы удалите здание то удалится и вся информация о нем</p>
      <p className="DeleteInfo">Введите слово "удалить" для подтверждения удаления здания:</p>
      <input className="DeleteInput" type="text" value={confirmation} onChange={handleConfirmationChange} />
      <button className="DeleteBTN" onClick={handleDelete} disabled={!confirmed}>
        Удалить
      </button>
    </div>
  );
};

export default ModalBuildingDelete;
